import React from "react";
import { Button } from "Components/ReactstrapSlim";
import { SigningEmailProps } from "./SigningCommon";

export interface EmailVerificationPendingFormProps extends SigningEmailProps {
   onBackClick: () => void;
}

export const EmailVerificationPendingForm: React.FC<EmailVerificationPendingFormProps> = function ({ onBackClick, ...signingEmailProps }) {

   return (
      <div className="signing-mode-inner signing-mode-inner--centered">
         <div className="signing-verification-pending">
            <div className="signing-verification-pending-icon"></div>
            <div className="signing-verification-pending-text">Email verification pending</div>
            <div className="signing-verification-pending-subtext">We have sent you an email for verification. Follow the instructions in the email to complete the verification process.</div>
            <Button className="signing-verification-pending-cta" onClick={onBackClick} color="primary" size="md" fluid>Got it</Button>
         </div>
      </div>
   )
}